<style scoped>
.modal-header {
  border-bottom: 1px solid #e1e1e1;
  margin: 0 -1rem;
  padding-left: 1rem
}
.modal-body {
  overflow-x: hidden
}
.content {
  margin: -1em -2em
}
hr, h5 {
  margin: 0
}
</style>

<template>
  <main class="modal modal-md3 active" id="modal-id">
    <a @click="close()" class="modal-overlay" aria-label="Close"></a>
    <div class="modal-container">
      <div class="modal-header">
        <div class="modal-title"><h5>Atividade na conta</h5></div>
      </div>
      <div class="modal-body">
        <div class="content">
          <dr-table
            v-if="rows.length > 0"
            class="table"
            :rows.sync="rows"
            :columns.sync="columns">
          </dr-table>
          <h2 class="text-center" v-else>Sem acessos</h2>
        </div>
      </div>
      <div class="modal-footer">
        <button @click="close()" class="btn btn-primary">Fechar</button>
      </div>
    </div>
  </main>
</template>

<script>
import data from '@/data/tableData/accessLog'
export default {
  props: ['rows'],
  data () {
    return {
      columns: data.columns
    }
  },
  methods: {
    close () {
      this.$emit('close', true)
    }
  }
}
</script>
